/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddAttachmentResponseContentDto } from '../models';
// @ts-ignore
import type { CreateDraftEmailResponseContentDto } from '../models';
// @ts-ignore
import type { EmailDraftDataDto } from '../models';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
/**
 * RestEmailUpdaterApi - axios parameter creator
 */
export const RestEmailUpdaterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {File} file 
         * @param {boolean} [inline] Obraz osadzony w treści wiadomości, nie zwykły załącznik. Dostaje Content-ID, a treść odwołuje się do niego przez src&#x3D;\\\&quot;cid:...\\\&quot;. Content-ID nadajemy WYŁĄCZNIE takim częściom — Exchange traktuje część z Content-ID, do której nikt się nie odwołuje, jak osierocony inline i usuwa ją z dostarczonej wiadomości.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment: async (userId: string, emailId: string, file: File, inline?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addAttachment', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('addAttachment', 'emailId', emailId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('addAttachment', 'file', file)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/attachments`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (inline !== undefined) { 
                localVarFormParams.append('inline', String(inline) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} userEmailFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanEmailsFromFolder: async (userId: string, userEmailFolderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('cleanEmailsFromFolder', 'userId', userId)
            // verify required parameter 'userEmailFolderId' is not null or undefined
            assertParamExists('cleanEmailsFromFolder', 'userEmailFolderId', userEmailFolderId)
            const localVarPath = `/api/users/{userId}/email-folders/{userEmailFolderId}/clean`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{userEmailFolderId}', encodeURIComponent(String(userEmailFolderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {EmailDraftDataDto} emailDraftDataDto 
         * @param {string} [resourceId] 
         * @param {ResourceTypeDto} [resourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftEmail: async (userId: string, emailDraftDataDto: EmailDraftDataDto, resourceId?: string, resourceType?: ResourceTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createDraftEmail', 'userId', userId)
            // verify required parameter 'emailDraftDataDto' is not null or undefined
            assertParamExists('createDraftEmail', 'emailDraftDataDto', emailDraftDataDto)
            const localVarPath = `/api/users/{userId}/emails`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailDraftDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} externalAttachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (userId: string, emailId: string, externalAttachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAttachment', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('deleteAttachment', 'emailId', emailId)
            // verify required parameter 'externalAttachmentId' is not null or undefined
            assertParamExists('deleteAttachment', 'externalAttachmentId', externalAttachmentId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/attachments/{externalAttachmentId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)))
                .replace('{externalAttachmentId}', encodeURIComponent(String(externalAttachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete email
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmail: async (userId: string, emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('deleteEmail', 'emailId', emailId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete email thread
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailThread: async (userId: string, emailThreadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteEmailThread', 'userId', userId)
            // verify required parameter 'emailThreadId' is not null or undefined
            assertParamExists('deleteEmailThread', 'emailThreadId', emailThreadId)
            const localVarPath = `/api/emails/{userId}/threads/{emailThreadId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailThreadId}', encodeURIComponent(String(emailThreadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark email as read
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEmailAsRead: async (userId: string, emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('markEmailAsRead', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('markEmailAsRead', 'emailId', emailId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/mark-as-read`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move emails to folder
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {string} targetUserEmailFolderId 
         * @param {string} sourceUserEmailFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveEmailsToFolder: async (userId: string, emailThreadId: string, targetUserEmailFolderId: string, sourceUserEmailFolderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('moveEmailsToFolder', 'userId', userId)
            // verify required parameter 'emailThreadId' is not null or undefined
            assertParamExists('moveEmailsToFolder', 'emailThreadId', emailThreadId)
            // verify required parameter 'targetUserEmailFolderId' is not null or undefined
            assertParamExists('moveEmailsToFolder', 'targetUserEmailFolderId', targetUserEmailFolderId)
            // verify required parameter 'sourceUserEmailFolderId' is not null or undefined
            assertParamExists('moveEmailsToFolder', 'sourceUserEmailFolderId', sourceUserEmailFolderId)
            const localVarPath = `/api/users/{userId}/emails/threads/{emailThreadId}/folders/move`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailThreadId}', encodeURIComponent(String(emailThreadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetUserEmailFolderId !== undefined) {
                localVarQueryParameter['targetUserEmailFolderId'] = targetUserEmailFolderId;
            }

            if (sourceUserEmailFolderId !== undefined) {
                localVarQueryParameter['sourceUserEmailFolderId'] = sourceUserEmailFolderId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {EmailDraftDataDto} emailDraftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftEmail: async (userId: string, emailId: string, emailDraftDataDto: EmailDraftDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateDraftEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('updateDraftEmail', 'emailId', emailId)
            // verify required parameter 'emailDraftDataDto' is not null or undefined
            assertParamExists('updateDraftEmail', 'emailDraftDataDto', emailDraftDataDto)
            const localVarPath = `/api/users/{userId}/emails/{emailId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailDraftDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmailUpdaterApi - functional programming interface
 */
export const RestEmailUpdaterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmailUpdaterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {File} file 
         * @param {boolean} [inline] Obraz osadzony w treści wiadomości, nie zwykły załącznik. Dostaje Content-ID, a treść odwołuje się do niego przez src&#x3D;\\\&quot;cid:...\\\&quot;. Content-ID nadajemy WYŁĄCZNIE takim częściom — Exchange traktuje część z Content-ID, do której nikt się nie odwołuje, jak osierocony inline i usuwa ją z dostarczonej wiadomości.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAttachment(userId: string, emailId: string, file: File, inline?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAttachmentResponseContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAttachment(userId, emailId, file, inline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.addAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} userEmailFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanEmailsFromFolder(userId: string, userEmailFolderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanEmailsFromFolder(userId, userEmailFolderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.cleanEmailsFromFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {EmailDraftDataDto} emailDraftDataDto 
         * @param {string} [resourceId] 
         * @param {ResourceTypeDto} [resourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftEmail(userId: string, emailDraftDataDto: EmailDraftDataDto, resourceId?: string, resourceType?: ResourceTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDraftEmailResponseContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftEmail(userId, emailDraftDataDto, resourceId, resourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.createDraftEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} externalAttachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(userId, emailId, externalAttachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.deleteAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete email
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmail(userId, emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.deleteEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete email thread
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailThread(userId, emailThreadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.deleteEmailThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark email as read
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markEmailAsRead(userId: string, emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markEmailAsRead(userId, emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.markEmailAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move emails to folder
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {string} targetUserEmailFolderId 
         * @param {string} sourceUserEmailFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveEmailsToFolder(userId: string, emailThreadId: string, targetUserEmailFolderId: string, sourceUserEmailFolderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveEmailsToFolder(userId, emailThreadId, targetUserEmailFolderId, sourceUserEmailFolderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.moveEmailsToFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {EmailDraftDataDto} emailDraftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDraftEmail(userId: string, emailId: string, emailDraftDataDto: EmailDraftDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDraftEmail(userId, emailId, emailDraftDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailUpdaterApi.updateDraftEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmailUpdaterApi - factory interface
 */
export const RestEmailUpdaterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmailUpdaterApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {File} file 
         * @param {boolean} [inline] Obraz osadzony w treści wiadomości, nie zwykły załącznik. Dostaje Content-ID, a treść odwołuje się do niego przez src&#x3D;\\\&quot;cid:...\\\&quot;. Content-ID nadajemy WYŁĄCZNIE takim częściom — Exchange traktuje część z Content-ID, do której nikt się nie odwołuje, jak osierocony inline i usuwa ją z dostarczonej wiadomości.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(userId: string, emailId: string, file: File, inline?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<AddAttachmentResponseContentDto> {
            return localVarFp.addAttachment(userId, emailId, file, inline, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} userEmailFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanEmailsFromFolder(userId: string, userEmailFolderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cleanEmailsFromFolder(userId, userEmailFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {EmailDraftDataDto} emailDraftDataDto 
         * @param {string} [resourceId] 
         * @param {ResourceTypeDto} [resourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftEmail(userId: string, emailDraftDataDto: EmailDraftDataDto, resourceId?: string, resourceType?: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateDraftEmailResponseContentDto> {
            return localVarFp.createDraftEmail(userId, emailDraftDataDto, resourceId, resourceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} externalAttachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAttachment(userId, emailId, externalAttachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete email
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEmail(userId, emailId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete email thread
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEmailThread(userId, emailThreadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark email as read
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEmailAsRead(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markEmailAsRead(userId, emailId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move emails to folder
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {string} targetUserEmailFolderId 
         * @param {string} sourceUserEmailFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveEmailsToFolder(userId: string, emailThreadId: string, targetUserEmailFolderId: string, sourceUserEmailFolderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveEmailsToFolder(userId, emailThreadId, targetUserEmailFolderId, sourceUserEmailFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {EmailDraftDataDto} emailDraftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftEmail(userId: string, emailId: string, emailDraftDataDto: EmailDraftDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDraftEmail(userId, emailId, emailDraftDataDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmailUpdaterApi - interface
 */
export interface RestEmailUpdaterApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {File} file 
     * @param {boolean} [inline] Obraz osadzony w treści wiadomości, nie zwykły załącznik. Dostaje Content-ID, a treść odwołuje się do niego przez src&#x3D;\\\&quot;cid:...\\\&quot;. Content-ID nadajemy WYŁĄCZNIE takim częściom — Exchange traktuje część z Content-ID, do której nikt się nie odwołuje, jak osierocony inline i usuwa ją z dostarczonej wiadomości.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAttachment(userId: string, emailId: string, file: File, inline?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<AddAttachmentResponseContentDto>;

    /**
     * 
     * @param {string} userId 
     * @param {string} userEmailFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cleanEmailsFromFolder(userId: string, userEmailFolderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {EmailDraftDataDto} emailDraftDataDto 
     * @param {string} [resourceId] 
     * @param {ResourceTypeDto} [resourceType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDraftEmail(userId: string, emailDraftDataDto: EmailDraftDataDto, resourceId?: string, resourceType?: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateDraftEmailResponseContentDto>;

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {string} externalAttachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete email
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete email thread
     * @param {string} userId 
     * @param {string} emailThreadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEmailThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Mark email as read
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markEmailAsRead(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Move emails to folder
     * @param {string} userId 
     * @param {string} emailThreadId 
     * @param {string} targetUserEmailFolderId 
     * @param {string} sourceUserEmailFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moveEmailsToFolder(userId: string, emailThreadId: string, targetUserEmailFolderId: string, sourceUserEmailFolderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {EmailDraftDataDto} emailDraftDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDraftEmail(userId: string, emailId: string, emailDraftDataDto: EmailDraftDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestEmailUpdaterApi - object-oriented interface
 */
export class RestEmailUpdaterApi extends BaseAPI implements RestEmailUpdaterApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {File} file 
     * @param {boolean} [inline] Obraz osadzony w treści wiadomości, nie zwykły załącznik. Dostaje Content-ID, a treść odwołuje się do niego przez src&#x3D;\\\&quot;cid:...\\\&quot;. Content-ID nadajemy WYŁĄCZNIE takim częściom — Exchange traktuje część z Content-ID, do której nikt się nie odwołuje, jak osierocony inline i usuwa ją z dostarczonej wiadomości.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addAttachment(userId: string, emailId: string, file: File, inline?: boolean, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).addAttachment(userId, emailId, file, inline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} userEmailFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cleanEmailsFromFolder(userId: string, userEmailFolderId: string, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).cleanEmailsFromFolder(userId, userEmailFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {EmailDraftDataDto} emailDraftDataDto 
     * @param {string} [resourceId] 
     * @param {ResourceTypeDto} [resourceType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDraftEmail(userId: string, emailDraftDataDto: EmailDraftDataDto, resourceId?: string, resourceType?: ResourceTypeDto, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).createDraftEmail(userId, emailDraftDataDto, resourceId, resourceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {string} externalAttachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).deleteAttachment(userId, emailId, externalAttachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete email
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).deleteEmail(userId, emailId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete email thread
     * @param {string} userId 
     * @param {string} emailThreadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEmailThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).deleteEmailThread(userId, emailThreadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark email as read
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markEmailAsRead(userId: string, emailId: string, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).markEmailAsRead(userId, emailId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move emails to folder
     * @param {string} userId 
     * @param {string} emailThreadId 
     * @param {string} targetUserEmailFolderId 
     * @param {string} sourceUserEmailFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveEmailsToFolder(userId: string, emailThreadId: string, targetUserEmailFolderId: string, sourceUserEmailFolderId: string, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).moveEmailsToFolder(userId, emailThreadId, targetUserEmailFolderId, sourceUserEmailFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {EmailDraftDataDto} emailDraftDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDraftEmail(userId: string, emailId: string, emailDraftDataDto: EmailDraftDataDto, options?: RawAxiosRequestConfig) {
        return RestEmailUpdaterApiFp(this.configuration).updateDraftEmail(userId, emailId, emailDraftDataDto, options).then((request) => request(this.axios, this.basePath));
    }
}

